import { h, render, Component } from 'preact';
import MarkersList from './markers-list/markers-list';
import './markers-tools-control-mobile.scss';
import TimeExpiration from './time-expiration/time-expiration';
import FollowObject from './follow-object/follow-object';
import injectTapEventPlugin from './preact-taps-event-plugin';
import Marker from './markers-list/marker/marker';
import TimePeriod from './time-period';
import moment from 'moment';

injectTapEventPlugin();

export default class MarkersToolsControlMobile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            markers: [],
            fromDate: null,
            toDate: null,
            loading: true,
            markersListOpen: false,
            allowTrack: false,
            timePeriodOpened: false,
            startTrackValue: moment().startOf('day'),
            endTrackValue: moment().endOf('day'),
            shownTracksByObjectsIds: [],
            isTrackLoading: false,
            activeKey: null
        };

        this.icons = {
        upShevron: [<path d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />],
            downShevron: [<path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />]
        };

        this.heights = {
            maxHeightWrapper: 477,
            minHeightWrapperWithTrack: 127,
            minHeightWrapper: 77
        }

        this.Map = document.getElementById('Map');
        this.markersToolsControlWrapper = document.querySelector('.markers-tools-control-wrapper-m');

    }

    componentDidMount() {
        this.props.radar.getMarkersRequest()
        .then((data) => {
            if (!!data) {
                const marker = data.objectsList[0];         
                this.setState({ 
                    markers: [...data.objectsList],
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    allowTrack: data.allowTrack,
                    loading: false,
                    activeKey: marker.id
                });
                window.addEventListener('resize', this.updateHeight);

                setTimeout(() => {
                    if (!this.markersToolsControlWrapper) {
                        this.markersToolsControlWrapper = document.querySelector('.markers-tools-control-wrapper-m');
                    }
                    this.markersToolsControlWrapper.style.transitionProperty = 'top';
                    this.markersToolsControlWrapper.style.transitionDuration = '0.5s';
                    this.updateHeight();
                }, 300);
                this.props.markersService.setMarkersOnMap(this.state.markers, 20);
                this.updateTimeout = setTimeout(() => { this.updateMarkersRequest() } , this.props.updateTimeoutValue);
                this.props.radar.setCurrentMarker(marker);
                let isToFollow = this.props.radar.isFollowObject();
                this.props.radar.setToFollow(true);
                this.props.radar.followObject();
                this.props.radar.setToFollow(isToFollow);
            }
        });
    }   

    getCurrentHeight() {
        return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateHeight);
    }

    updateMarkersRequest() {
        this.props.radar.updateMarkersRequest()
        .then((data) => {
            this.props.markersService.updateMarkers(data);
            this.setState({ markers: this.getUpdatesMarkers(data) });
            this.props.radar.setCurrentMarker(this.state.markers.filter(item => item.id === this.state.activeKey)[0]);
            this.props.radar.followObject();
            this.updateTimeout = setTimeout(() => { this.updateMarkersRequest() } , this.props.updateTimeoutValue);
        });            
    }

    getUpdatesMarkers(updateData) {
        return this.state.markers.reduce((arr, e) => {
            let newMarker = {...e};
            let updateDataElement = updateData.filter(item => item.id == e.id);
            if (!!updateDataElement[0]) {
                for(let prop in updateDataElement[0]) {
                    newMarker[prop] = updateDataElement[0][prop];
                }
            }
            arr.push(newMarker);
            return arr;
        },[]);
    }

    handleTap = () => {
        this.setState({ markersListOpen: !this.state.markersListOpen});
        this.updateHeight();        
    }

    handleSwipeUp = () => {
        if (!this.state.markersListOpen) {         
            this.setState({
                markersListOpen: !this.state.markersListOpen
            });
            this.updateHeight();
        }
    }

    handleSwipeDown = () => {
        if (this.state.markersListOpen) {
            this.setState({
                markersListOpen: !this.state.markersListOpen
            });
            this.updateHeight();
        }
    }

    _onTapMarker(marker, e) {
        e.stopPropagation();
        this.setState({
            activeKey:marker.id
        });
        this.handleTap();
        this.props.radar.setCurrentMarker(marker);
        let isToFollow = this.props.radar.isFollowObject();
        this.props.radar.setToFollow(true);
        this.props.radar.followObject();
        this.props.radar.setToFollow(isToFollow);
    }

    updateHeight = () => {
        const hB = this.getCurrentHeight();
        this.Map.style.height = hB + 'px';

        if (this.state.markersListOpen) {
            this.markersToolsControlWrapper['style'].top = (hB - this.heights.maxHeightWrapper) + 'px';
        } else {
            let minHeight = this.state.allowTrack
                ? this.heights.minHeightWrapperWithTrack
                : this.heights.minHeightWrapper;
            this.markersToolsControlWrapper['style'].top = (hB - minHeight) + 'px';
        }
    };

    _getTrackPeriodString = () => {
        let result = '';
        result += this.state.startTrackValue.format('DD.MM.YYYY HH:mm:ss');
        result += ' - ';
        result += this.state.endTrackValue.format('DD.MM.YYYY HH:mm:ss');
        return result;
    }

    _openTimePeriod = (event) => {
        event.stopPropagation();
        this.setState({ timePeriodOpened: true });
    }

    _closeTimePeriod = () => {
        this.setState({ timePeriodOpened: false });
    }

    _updateTimePeriod = (startTrackValue, endTrackValue) => {
        this.setState({ startTrackValue, endTrackValue });
    }

    _requestTrack = () => {
        let {
            activeKey: objectId,
            startTrackValue,
            endTrackValue,
            isTrackLoading
        } = this.state;
        if (isTrackLoading) {
            return;
        }
        let startTime = startTrackValue.format('YYYY-MM-DD HH:mm:ss');
        let stopTime = endTrackValue.format('YYYY-MM-DD HH:mm:ss');

        this.setState({ isTrackLoading: true });
        let self = this;
        this.props.radar.getTrackRequest({ objectId, startTime, stopTime })
        .then(routeInfo => {
            if (!routeInfo) {
                self.setState({ isTrackLoading: false });
                return;
            }
            self.props.routesService.setRouteOnMap(routeInfo, {
                trackStyle: 'object',
                showFuelings: false,
                showStops: true
            });
            let { shownTracksByObjectsIds } = this.state;
            shownTracksByObjectsIds.push(objectId);
            self.setState({
                shownTracksByObjectsIds,
                isTrackLoading: false
            });
        });
    }

    _removeTrack = () => {
        let objectId = this.state.activeKey;
        let tracks = this.state.shownTracksByObjectsIds;

        this.props.routesService.clearRoute(objectId);
        let shownTracksByObjectsIds = tracks.filter(id => id != objectId);
        this.setState({ shownTracksByObjectsIds });
    }

    render (props, state) {
        const propsEventsWrapper ={};
        if (state.markers.length > 1) {
            propsEventsWrapper['onTouchTap'] = () => this.handleTap();
            propsEventsWrapper['onSwipeUp'] = () => this.handleSwipeUp();
            propsEventsWrapper['onSwipeDown'] = () => this.handleSwipeDown();
        }

        const infoPanelButtonClasses = state.markers.length > 1
            ?"info-panel-button-m"
            :"info-panel-button-with-one-object-m";

        const infoPanelWrapperClasses = state.markers.length > 1
            ?"info-panel-wrapper-m"
            :"info-panel-wrapper-with-one-object-m";

        let isTrackOnMap = state.shownTracksByObjectsIds.includes(state.activeKey);

        return (
            <div>
                {
                    !this.state.loading &&
                    <TimeExpiration 
                        radar={props.radar}
                        fromDate={state.fromDate}
                        toDate={state.toDate}
                    />
                }
                {   
                    !this.state.loading &&
                    <div class="markers-tools-control-wrapper-m" {...propsEventsWrapper}>
                        <div class={infoPanelButtonClasses}>
                            {
                                state.markers.length > 1 &&                            
                                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                    {
                                        this.state.markersListOpen &&
                                        this.icons.downShevron
                                    }
                                    {
                                        !this.state.markersListOpen &&
                                        this.icons.upShevron
                                    }                                
                                </svg>
                            }
                        </div>
                        {
                            this.state.allowTrack &&
                            <div class="track-panel">
                                <div
                                    class="track-panel-period"
                                    onTouchTap={this._openTimePeriod}
                                >
                                    <span class="track-panel-period-label">
                                        {fmtools.translate('Period')}
                                    </span>
                                    <span class="track-panel-period-value">
                                        {this._getTrackPeriodString()}
                                    </span>
                                </div>
                                {
                                    isTrackOnMap &&
                                    <div
                                        class="track-panel-button"
                                        onTouchTap={this._removeTrack}
                                    >
                                        <span class="track-panel-button-text">
                                            {fmtools.translate('RemoveTrack')}
                                        </span>
                                    </div>
                                }
                                {
                                    !isTrackOnMap &&
                                    <div
                                        class="track-panel-button"
                                        onTouchTap={this._requestTrack}
                                    >
                                        {
                                            state.isTrackLoading &&
                                            <div class="track-loading-icon" />
                                        }
                                        {
                                            !state.isTrackLoading &&
                                            <span class="track-panel-button-text">
                                                {fmtools.translate('RequestTrack')}
                                            </span>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <div class={infoPanelWrapperClasses}>
                            <div class="info-panel-m">
                                {
                                    !!state.activeKey &&
                                    <Marker
                                        marker={state.markers.filter(m => m.id === state.activeKey)[0]}
                                        active=""
                                        disabled={true}
                                    />
                                }
                                {
                                    !state.activeKey &&
                                    <div>Fort Monitor Radar</div>
                                }                                
                            </div>
                            <FollowObject radar={props.radar}/>
                        </div>
                        {
                            state.markers.length > 1 &&
                            <MarkersList
                                radar={props.radar}
                                markers={state.markers}
                                onTapMarker={this._onTapMarker.bind(this)}
                                activeKey={state.activeKey}
                            />
                        }
                    </div>
                }
                {
                    this.state.loading &&
                    <div class="markers-list-loader-wrapper-m">
                        <div class="markers-tools-control-loader-m"></div>
                    </div>
                }
                {
                    state.timePeriodOpened &&
                    <TimePeriod
                        updatePeriod={this._updateTimePeriod}
                        close={this._closeTimePeriod}
                    />
                }
            </div>
        );
    }
}